import { render, staticRenderFns } from "./itemManage.vue?vue&type=template&id=d2ed6a6e&scoped=true&"
import script from "./itemManage.vue?vue&type=script&lang=js&"
export * from "./itemManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ed6a6e",
  null
  
)

export default component.exports